import React, { Component } from 'react'
import formhoc from './formhoc';
import BookingInput from '../Booking/bookinginput';
import { contact_api } from '../../actions/http';
import ButtonLoader from '../btnloader';


class RegisterStore extends Component {
    render() {
        const {ipState, onChange, formFilled} = this.props;
        const { business_name,bussiness_name_err,business_type,business_type_err,contact_person,contact_person_err,contact_number1,contact_number1_err,contact_number2,contact_number2_err,mail_id,mail_id_err,website,website_err,address_line1,address_line1_err,address_line2,address_line2_err,postal_code,postal_code_err,country,country_err,location, form_fetching } = ipState;
        return (
            
            <div>
                <h3 className="f-600 m-b-10 m-t-10">Register Your Store</h3>
                <div className="row" >
                    <BookingInput 
                        size={8} 
                        type="text"
                        name="business_name"
                        onChange={onChange}
                        placeholder="Business Name" 
                        value={business_name}
                        err={bussiness_name_err}
                        
                    />
                  
                    <BookingInput 
                        size={8} 
                        type="text"
                        name="business_type"
                        placeholder="Business Type" 
                        
                        onChange={onChange}
                        value={business_type}
                        err={business_type_err}

                        
                    />
                      <BookingInput 
                        size={8} 
                        type="text"
                        name="contact_person"
                        onChange={onChange}
                        placeholder="Contact Person"
                        value={contact_person}
                        err={contact_person_err}

                       
                    />
                    <BookingInput 
                        size={8} 
                        type="number"
                        name="contact_number1"
                        placeholder="Contact Number1" 
                        maxLength={10}
                        onChange={onChange}
                        value={contact_number1}
                        err={contact_number1_err}
                       
                    />
                    <BookingInput 
                        size={8} 
                        type="number"
                        name="contact_number2"
                        placeholder="Contact Number2" 
                        maxLength={12}
                        onChange={onChange}
                        value={contact_number2}
                        err={contact_number2_err}
                       
                    />


                    <BookingInput 
                        size={8} 
                        type="text"
                        name="mail_id"
                        placeholder="Mail Id" 
                        maxLength={15}
                        onChange={onChange}
                        value={mail_id}
                        err={mail_id_err}
                    />
                    

                       <BookingInput 
                        size={8} 
                        type="text"
                        name="address_line1"
                        placeholder="Address Line1" 
                        maxLength={20}
                        onChange={onChange}
                        value={address_line1}
                        err={address_line1_err}
                       
                    />

                       <BookingInput 
                        size={8} 
                        type="text"
                        name="address_line2"
                        placeholder="Address Line2" 
                        maxLength={20}
                        onChange={onChange}
                        value={address_line2}
                        err={address_line2_err}
                        
                    />
                     <BookingInput 
                        size={8} 
                        type="text"
                        name="postal_code"
                        placeholder="Postal Code" 
                        maxLength={10}
                        onChange={onChange}
                        value={postal_code}
                        err={postal_code_err}
                        
                    />
<BookingInput 
                        size={8} 
                        type="text"
                        name="country"
                        placeholder="Country" 
                        maxLength={10}
                        onChange={onChange}
                        value={country}
                        err={country_err}
                        
                    />

 <div className="col-md-8">
                        <select value={location} onChange={onChange} name="location" className="form-control input-md" >
                            <option value="Chennai">Chennai</option>
                            <option value="Coimbatore">Coimbatore</option>
                            <option value="Neyveli">Neyveli</option>
                           
                        </select>
                    </div>
                    <div className="col-md-8">
                        <button disabled={formFilled && !form_fetching ? false : true} type="submit" className="btn m-t-10 btn-block btn-ouja">{ form_fetching ? <ButtonLoader /> : 'Submit' }</button>
                    </div>
                </div>
           </div>
           
        )
    }
}

const inputs = [
    {
        name: "business_name"
    },
    {
        name: "bussiness_type"
    },
    {
        name: "contact_person"
    },
    {
        name: "contact_number1"
    },
    {
        name: "contact_number2"
    },
    
    {
        name: "mail_id"
        
    },
    {
        name: "website"
        
    },
    {
        name: "address_line1"
        
    },
    {
        name: "address_line2"
        
    },
    {
        name: "postal_code"
        
    },
    {
        name: "country"
        
    },
    
    {
        name: "location",
        defaultValue: "Chennai"
    },
    {
        name: "type",
        defaultValue: 2
    }
];

const formConfig = {
    url: contact_api,
    method: "POST" 
};

export default formhoc(RegisterStore, inputs, formConfig);
